export function pluralize<T>(title: "מנוע", list: T[]) {
  const size = list?.length ?? 0
  if (size == 0) return null
  switch (title) {
    case "מנוע":
      return size == 1 ? title : "מנועים"
  }
}
